import _uniqBy from 'lodash/uniqBy'
import _cloneDeep from 'lodash/cloneDeep'
import {
  UserAttrs,
  DeptAttrs
} from './config'

const bailRE = /[^\w.$]/
export function parsePath (path) {
  if (bailRE.test(path)) return
  const segments = path.split('.')

  return function (obj) {
    for (let i = 0, l = segments.length; i < l; i++) {
      if (!obj) return
      obj = obj[segments[i]]
    }
    return obj
  }
}

/**
 * @description 获取组织对象的参数值
 * @param {Object} orgObj 组织对象
 * @param {Array} paramConfig 参数配置
 */
function getParamValue (orgObj, paramConfig) {
  if (orgObj) {
    for (let i = 0, len = paramConfig.length; i < len; i++) {
      const param = paramConfig[i]
      const value = parsePath(param)(orgObj)
      if (
        value !== undefined &&
        value !== null &&
        value !== ''
      ) {
        // 获取的属性包含：id、name、path 其类型都为字符串
        return String(value)
      }
    }
  }
  return ''
}

/**
 * @description 格式化员工数据
 * @param {Object} employee 员工数据
 */
function normalEmployee (employee) {
  if (employee && typeof employee === 'object') {
    const data = _cloneDeep(employee)
    const user = {}
    Object.keys(UserAttrs).forEach(name => {
      user[name] = getParamValue(data, UserAttrs[name])
    })
    return Object.assign(data, user)
  }
  return null
}

/**
 * @description 格式化员工列表
 * @param {Array} employeesList 员工列表
 */
function normalEmployeeList (employeesList) {
  if (Array.isArray(employeesList)) {
    return _uniqBy(employeesList.map(employee => {
      return normalEmployee(employee)
    }), 'userId')
  }
  return []
}

/**
 * @description 格式化部门数据
 * @param {Object} department 部门数据
 */
function normalDepartment (department) {
  if (department && typeof department === 'object') {
    const data = _cloneDeep(department)
    const dept = {}
    Object.keys(DeptAttrs).forEach(name => {
      dept[name] = getParamValue(data, DeptAttrs[name])
    })
    return Object.assign(data, dept)
  }
  return null
}

/**
 * @description 格式化部门列表
 * @param {Array} departmentsList 部门列表
 */
function normalDepartmentList (departmentsList) {
  if (Array.isArray(departmentsList)) {
    return _uniqBy(departmentsList.map(department => {
      return normalDepartment(department)
    }), 'deptId')
  }
  return []
}

/**
 * @description 格式化组织单位
 * @param {Array} departmentsList 组织单位
 */
function normalOrgItem (item, type) {
  if (!item) return null
  let _item = item
  // 检测是否是用户单位
  if (type === 'user' || !type) {
    _item = normalEmployee(item)
    // 部门数据不会有 mucUid
    if (_item && _item.mucUid) {
      _item.orgType = 'user'
      _item.orgId = _item.userId
      _item.orgName = _item.userName
      return _item
    }
  }
  // 检测是否是部门单位
  if (type === 'dept' || !type) {
    _item = normalDepartment(item)
    if (_item && _item.deptId) {
      _item.orgType = 'dept'
      _item.orgId = _item.deptId
      _item.orgName = _item.deptName
      return _item
    }
  }
  return null
}

/**
 * @description 格式化组织列表
 * @param {Array} departmentsList 组织列表
 */
function normalOrgList (list, type) {
  if (Array.isArray(list)) {
    return _uniqBy(list.map(item => {
      return normalOrgItem(item, type)
    }), 'orgId')
  }
  return []
}

export {
  getParamValue,
  normalEmployee,
  normalEmployeeList,
  normalDepartment,
  normalDepartmentList,
  normalOrgItem,
  normalOrgList
}
